// extracted by mini-css-extract-plugin
export default {"socials":"Socials_socials__mPx6i"};